export default __webpack_public_path__ + "static/media/B17.10aa9c9f.mp4";